export const ReissueCardUpgradeRoutes = {
    ROOT: "/reissue-card-upgrade",
};


// WEBPACK FOOTER //
// ./src/components/reissueCardUpgrade/ReissueCardUpgradeRoutes.ts